import { compose, withHandlers, withProps, withState } from 'recompose';
import { connect } from 'react-redux';

import { t } from '../../../../../../modules/infra/i18n';
import withNotifications from '../../../../../common/withNotifications';
import { getActiveShopId, getIsRentalShop } from '../../../../../auth/selectors';
import { AUTO_PAYOUT_ELIGIBILITY_BARBER_BANK_ACCOUNT_URL } from '../../../../../common/KnowledgeArticleLink/constants';
import withToggle from '../../../../../common/hoc/withToggle';
import BarberBankAccountsStep from './BarberBankAccountsStep';
import { getCollection as getShopBarbersById } from '../../../../barbers/selector';
import { getNotifiedBarbersResult, getPopulatedBarbersWithoutBankAccount } from '../../utils';
import { notifyBarbersBankAccount } from '../../actions';

export default compose(
  withNotifications,
  connect((state, ownProps) => ({
    shopId: getActiveShopId(state),
    isRentalShop: getIsRentalShop(state),
    barbersWithIssues: getPopulatedBarbersWithoutBankAccount(ownProps.barbersWithIssues, getShopBarbersById(state)),
  })),
  withToggle('notifyBarbersModal', false),
  withToggle('barbersNotifiedModal', false),
  withState('barbersNotifiedResult', 'setBarbersNotifiedResult', []),
  withProps(() => ({
    name: t('settings:auto_payout.barber_bank_accounts'),
    description: t('settings:auto_payout.barber_accounts_description'),
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_BARBER_BANK_ACCOUNT_URL,
    eligibilityActionDescription: t('settings:auto_payout.notify_barbers'),
  })),
  withHandlers({
    onOpenBarbersNotifiedModal: props => (barbersNotifiedApiResult) => {
      props.setBarbersNotifiedResult(
        getNotifiedBarbersResult(barbersNotifiedApiResult, props.barbersWithIssues)
      );
      props.barbersNotifiedModalOn();
    },

    onCloseBarbersNotifiedModal: props => () => {
      props.setBarbersNotifiedResult([]);
      props.barbersNotifiedModalOff();
    },
  }),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      if (props.isRentalShop) {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.no_commission_barbers_error'),
        });

        return;
      }

      props.notifyBarbersModalOn();
    },
    onSendBarberEmails: props => async () => {
      props.notifyBarbersModalOff();

      const barbersNotifiedApiResult = await notifyBarbersBankAccount(
        props.shopId,
        props.barbersWithIssues.map(barber => barber.id)
      );

      if (barbersNotifiedApiResult.status === 'ok') {
        props.onOpenBarbersNotifiedModal(barbersNotifiedApiResult);
      } else {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.action_failed_error'),
        });
      }
    },
  })),
)(BarberBankAccountsStep);
